exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/.store/core-js@2.6.12/~/core-js/library/modules/_wks-ext.js
// module id = 246
// module chunks = 75